import { render, staticRenderFns } from "./StatusAndWorkCertificates.vue?vue&type=template&id=bc2f9934"
import script from "./StatusAndWorkCertificates.vue?vue&type=script&lang=js"
export * from "./StatusAndWorkCertificates.vue?vue&type=script&lang=js"
import style0 from "./StatusAndWorkCertificates.vue?vue&type=style&index=0&id=bc2f9934&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports